(function() {
  const settings = window.memberPricing || {};
  const discountPercent = Number(settings.discountPercent || 0);

  function isEnabled(productTags = []) {
    return Boolean(settings.enabled && discountPercent > 0 && !productTags.includes('no-member-discount'));
  }

  function getPrice(price, compareAtPrice = 0, productTags = []) {
    const cents = Number(price || 0);
    const compareAtCents = Number(compareAtPrice || 0);

    if (!isEnabled(productTags)) {
      return {
        price: cents,
        compareAtPrice: compareAtCents > cents ? compareAtCents : null,
        isMemberPrice: false,
      };
    }

    const memberPrice = Math.ceil(cents * (100 - discountPercent) / 100);
    const memberCompareAtPrice = compareAtCents > cents ? compareAtCents : cents;

    return {
      price: memberPrice,
      compareAtPrice: memberCompareAtPrice > memberPrice ? memberCompareAtPrice : null,
      isMemberPrice: true,
    };
  }

  function getDisplayPrice(variant, productTags = []) {
    const price = Number(variant?.price || 0);
    const compareAtPrice = Number(variant?.compare_at_price || 0);
    const memberPrice = getPrice(price, compareAtPrice, productTags);

    if (memberPrice.isMemberPrice) {
      return memberPrice;
    }

    return {
      price,
      compareAtPrice: compareAtPrice > price ? compareAtPrice : null,
      isMemberPrice: false,
    };
  }

  function getCartLineDisplayPrice(item) {
    const quantity = Math.max(1, Number(item?.quantity || 1));
    const finalLinePrice = Number(item?.final_line_price ?? item?.line_price ?? 0);
    const originalLinePrice = Number(item?.original_line_price ?? item?.line_price ?? finalLinePrice);
    const compareAtPrice = Number(
      item?.properties?._jersey_compare_at_price ||
      item?.variant_compare_at_price ||
      item?.product?.compare_at_price ||
      0
    );
    const catalogUnitPrice = Number(item?.original_price ?? item?.price ?? 0);
    const validCompareAtPrice = compareAtPrice > catalogUnitPrice ? compareAtPrice : 0;
    const referenceLinePrice = Math.max(originalLinePrice, validCompareAtPrice * quantity);

    return {
      price: finalLinePrice,
      compareAtPrice: referenceLinePrice > finalLinePrice ? referenceLinePrice : null,
    };
  }

  window.memberPricing = {
    ...settings,
    getPrice,
    getDisplayPrice,
    getCartLineDisplayPrice,
    isEnabled,
  };
})();
